import { Progress, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { ClockLoader } from 'react-spinners';

const Loader = ({ spinning, children }) => {
  // const [spinning, setSpinning] = useState(false);
  // const [percent, setPercent] = useState(0);

  // useEffect(() => {
  //   let interval;

  //   if (initialSpinning) {
  //     setSpinning(true);
  //     setPercent(0);
  //     let progress = 0;

  //     // Simulate progress increment
  //     interval = setInterval(() => {
  //       progress += 5;
  //       setPercent(progress);

  //       if (progress >= 100) {
  //         clearInterval(interval);
  //         setTimeout(() => {
  //           setSpinning(false);
  //           setPercent(0);
  //         }, 500); // Delay to show completed loader
  //       }
  //     }, 100);
  //   } else {
  //     // Stop spinning if spinning is false
  //     clearInterval(interval);
  //     setSpinning(false);
  //     setPercent(0);
  //   }

  //   return () => clearInterval(interval); // Cleanup on unmount or spinning change
  // }, [initialSpinning]);
  return (
    <div style={{ position: 'relative' }}>
      {spinning && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10, // Ensure it's on top of the table
          }}
        >
          {/* <Spin spinning={spinning} /> */}
          {/* <div className="tw-flex tw-flex-col">
            <ClockLoader color="#10a96ff1" />
          </div> */}

          <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
            <ClockLoader color="#10a96ff1" />
            <div className="tw-text-green-600 tw-mt-2 tw-font-medium">
              Loading, please wait...
            </div>
          </div>

          {/* <Progress
            type="circle"
            percent={percent}
            style={{ marginTop: '20px' }}
          /> */}
        </div>
      )}
      {children}
    </div>
  );
};

export default Loader;
